/**
 * Shadow flags helper (Graphics G3).
 *
 * Sets castShadow/receiveShadow on every renderable under an object — handles a plain
 * Mesh, a cloned GLB hierarchy, an InstancedMesh, and a THREE.LOD's per-level meshes.
 * CSMShadowNode (the WebGPU CSM) needs no per-material setup, so flipping the flags is
 * all a caster/receiver needs.
 */
import * as THREE from 'three/webgpu';

export function enableShadows(obj: THREE.Object3D, cast: boolean, receive: boolean): void {
  obj.traverse((o) => {
    const m = o as THREE.Mesh & { isMesh?: boolean; isInstancedMesh?: boolean };
    if (m.isMesh || m.isInstancedMesh) { m.castShadow = cast; m.receiveShadow = receive; }
  });
}
